import React, { useEffect, useState } from "react";
import { toast } from "sonner";
import { Loader2 } from "lucide-react";
import { api, errMsg } from "../../../lib/api";

const FIELDS = [
  ["play_store_url", "Google Play link", "https://play.google.com/store/apps/details?id=org.ishukart.app"],
  ["app_store_url", "App Store link", "https://apps.apple.com/in/app/ishukart/id1234567890"],
];

export const StoreLinksForm = ({ data, onSaved }) => {
  const [form, setForm] = useState({ play_store_url: "", app_store_url: "" });
  const [busy, setBusy] = useState(false);
  useEffect(() => {
    setForm({ play_store_url: data?.android?.play_store_url || "", app_store_url: data?.ios?.app_store_url || "" });
  }, [data]);
  const save = async (e) => {
    e.preventDefault();
    setBusy(true);
    try { onSaved(await api.adminSaveMobileApp(form)); toast.success("Store links saved — the Get the app page is updated"); }
    catch (err) { toast.error(errMsg(err)); }
    finally { setBusy(false); }
  };
  return (
    <form onSubmit={save} className="rounded-2xl border border-slate-200 bg-white p-5 sm:p-6" data-testid="mobile-store-links-form">
      <h2 className="font-display text-lg font-semibold text-slate-900">Store links</h2>
      <p className="mt-1 text-sm text-slate-500">Paste each link once the app is live in that store. Leave empty to show "Coming soon".</p>
      <div className="mt-5 space-y-4">
        {FIELDS.map(([key, label, ph]) => (
          <label key={key} className="block">
            <span className="text-xs font-semibold uppercase tracking-wider text-slate-500">{label}</span>
            <input value={form[key]} onChange={(e) => setForm({ ...form, [key]: e.target.value })} placeholder={ph} data-testid={`mobile-${key.replace(/_/g, "-")}-input`}
              className="mt-1.5 w-full h-11 px-3.5 rounded-lg bg-slate-50 border border-slate-200 text-sm font-mono text-slate-800 outline-none focus:border-sky-400" />
          </label>
        ))}
      </div>
      <button disabled={busy} data-testid="mobile-store-links-save" className="mt-5 h-10 px-5 inline-flex items-center gap-2 rounded-lg bg-slate-900 text-white text-sm font-semibold hover:bg-slate-700 disabled:opacity-60">
        {busy && <Loader2 size={14} className="animate-spin" />} Save links
      </button>
    </form>
  );
};

export default StoreLinksForm;
